import $ from 'jquery';
import ko from 'knockout';

export default function Question(data) {
    $.extend(this, data, {
        response: ko.observable(data.response)
    });
}
